/** @jsx jsx */
import { css, jsx } from "@emotion/core";

const SubTitle = ({ text }) => (
  <p css={styles} className="subtitle">
    {text}
  </p>
);

const styles = css`
  font-size: 15px;
  color: #fff;
  margin-bottom: 10px;
`;

export default SubTitle;
